import React from "react";
import * as module from './breadcrumb.module.css'
let classes = module
// import { Link, useLocation } from 'react-router-dom';
export default function BreadCrumbs({ breadcrumbs, rightslot , className}) {
	let stepClass;

	return (
		<ul className={`${classes.breadcrumbs} ${className}`}>
			{breadcrumbs.map((page, index) => {
				page.current
					? (stepClass = classes.currentStep)
					: (stepClass = classes.previousStep);
				return (
					<li
						key={page.name}
					>
						{index > 0 && (
							<svg
								className={classes.breadcrumbChevron}
								width="20"
								viewBox="0 0 16 16"
							>
								<path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z"></path>
							</svg>
						)}
						<a className={classes.linked} href={page.href}>
							{page.name}
						</a>
					</li>
				);
			})}
		    {rightslot ? (
				<>
					<li className="flex-grow"></li>
					<li className={classes.breadcrumbsActions}>{rightslot}</li>
				</>
        	) : null}
      </ul>
	);
}
